<template>
  <div>
    <AtomsLabel class="mb-2" :is-error="isError">
      <div v-if="requiredLabelLayout === 'row'" :class="style({ hasNote })">
        <p :class="labelStyle({ required, lang })" v-html="label"></p>
        <AtomsRequiredLabel v-if="required" :lang="lang" />
      </div>
      <div v-else :class="colStyle({ hasNote })">
        <p :class="labelStyle({ required, lang })" v-html="label"></p>
        <AtomsRequiredLabel v-if="required" :lang="lang" />
      </div>
      <p v-if="hasNote" class="text-xs md:text-sm" v-html="note"></p>
    </AtomsLabel>
    <slot />
    <AtomsParagraphSub v-if="hasHelperText" class="text-gray2">{{ helperText }}</AtomsParagraphSub>
    <AtomsErrorText v-if="isError" :lang="lang">{{ error }}</AtomsErrorText>
  </div>
</template>

<script setup lang="ts">
import { tv } from 'tailwind-variants';

import type { Lang } from '@/models/lang';

interface Props {
  label: string;
  note?: string;
  required?: boolean;
  error?: string;
  lang?: Lang;
  helperText?: string;
  requiredLabelLayout?: 'col' | 'row';
}

const props = withDefaults(defineProps<Props>(), {
  required: true,
  note: '',
  error: '',
  lang: 'jp',
  helperText: '',
  requiredLabelLayout: 'row',
});
const hasNote = computed(() => !!props.note && props.note !== '');
const hasHelperText = computed(() => !!props.helperText && props.helperText !== '');
const isError = computed(() => !!props.error && props.error !== '');

/**
 * Style
 */
const style = tv({
  base: 'flex items-center',
  variants: {
    hasNote: {
      true: 'mb-1',
    },
  },
});

const colStyle = tv({
  base: 'flex flex-col items-start gap-2',
  variants: {
    hasNote: {
      true: 'mb-1',
    },
  },
});

const labelStyle = tv({
  variants: {
    required: {
      true: 'mr-2',
    },
    lang: {
      jp: '',
      en: 'text-base tracking-normal text-black2',
    },
  },
});
</script>
